"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _FlamingoEDSNeo3_network, _FlamingoEDSNeo3_axiosInstance;
Object.defineProperty(exports, "__esModule", { value: true });
exports.FlamingoEDSNeo3 = void 0;
const blockchain_service_1 = require("@cityofzion/blockchain-service");
const axios_1 = __importDefault(require("axios"));
const BSNeo3Helper_1 = require("../../helpers/BSNeo3Helper");
class FlamingoEDSNeo3 extends blockchain_service_1.CryptoCompareEDS {
    constructor(network) {
        super();
        _FlamingoEDSNeo3_network.set(this, void 0);
        _FlamingoEDSNeo3_axiosInstance.set(this, void 0);
        __classPrivateFieldSet(this, _FlamingoEDSNeo3_network, network, "f");
        __classPrivateFieldSet(this, _FlamingoEDSNeo3_axiosInstance, axios_1.default.create({ baseURL: 'https://api.flamingo.finance' }), "f");
    }
    getTokenPrices(params) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!BSNeo3Helper_1.BSNeo3Helper.isMainnet(__classPrivateFieldGet(this, _FlamingoEDSNeo3_network, "f")))
                throw new Error('Exchange is only available on mainnet');
            const { data } = yield __classPrivateFieldGet(this, _FlamingoEDSNeo3_axiosInstance, "f").get('/token-info/prices');
            const prices = [];
            data.forEach(item => {
                const token = params.tokens.find(token => BSNeo3Helper_1.BSNeo3Helper.normalizeHash(token.hash) === BSNeo3Helper_1.BSNeo3Helper.normalizeHash(item.hash));
                if (!token)
                    return;
                prices.push({
                    usdPrice: item.usd_price,
                    token,
                });
            });
            return prices;
        });
    }
    getTokenPriceHistory(params) {
        const _super = Object.create(null, {
            getTokenPriceHistory: { get: () => super.getTokenPriceHistory }
        });
        return __awaiter(this, void 0, void 0, function* () {
            if (!BSNeo3Helper_1.BSNeo3Helper.isMainnet(__classPrivateFieldGet(this, _FlamingoEDSNeo3_network, "f")))
                throw new Error('Exchange is only available on mainnet');
            return yield _super.getTokenPriceHistory.call(this, params);
        });
    }
}
exports.FlamingoEDSNeo3 = FlamingoEDSNeo3;
_FlamingoEDSNeo3_network = new WeakMap(), _FlamingoEDSNeo3_axiosInstance = new WeakMap();
